module.exports = __webpack_public_path__ + "img/ic-arrow.49e40ddf.svg";